import React from "react";
import Header from "../../component/header/header";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./founder.css";
import Footer from "../../component/footer/footer";

const Founder = () => {
  return (
    <div>
      <Header />

      {/* secound section */}

      {/* =========================
     1. Mission & Vision Section
========================= */}
      <Container className="mission-section py-5">
        <Row className="align-items-center">
          <Col md={6}>
            <motion.img
              src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg"
              alt="Mission"
              className="mission-img"
              initial={{ opacity: 0, x: -90 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9 }}
            />
          </Col>

          <Col md={6}>
            <motion.div
              initial={{ opacity: 0, x: 90 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9 }}
            >
              <h2 className="section-title">Our Mission</h2>
              <p className="section-para">
                Our mission is to create a startup community where innovators,
                creators, and founders can collaborate and grow together.
              </p>

              <h2 className="section-title mt-4">Our Vision</h2>
              <p className="section-para">
                We aim to empower new entrepreneurs with opportunities,
                mentorship, and resources to build successful businesses.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>

      {/* =========================
     2. Startup Journey / Timeline
========================= */}
      <Container fluid className="timeline-section py-5">
        <Container>
          <motion.h2
            className="text-center mb-5"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Our Startup Journey
          </motion.h2>

          <div className="timeline">
            <motion.div
              className="timeline-box"
              initial={{ opacity: 0, x: -120 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h4>2019</h4>
              <p>Idea & Vision Created</p>
            </motion.div>

            <motion.div
              className="timeline-box"
              initial={{ opacity: 0, x: 120 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h4>2020</h4>
              <p>Startup Registered</p>
            </motion.div>

            <motion.div
              className="timeline-box"
              initial={{ opacity: 0, x: -120 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h4>2022</h4>
              <p>Team Formation</p>
            </motion.div>

            <motion.div
              className="timeline-box"
              initial={{ opacity: 0, x: 120 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h4>2024</h4>
              <p>First Investor Onboarded</p>
            </motion.div>
          </div>
        </Container>
      </Container>

      {/* =========================
     3. Why Join Us Section
========================= */}
      <Container className="why-join py-5">
        <motion.h2
          className="text-center mb-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
        >
          Why Join Our Founder Network?
        </motion.h2>

        <Row className="g-4">
          {[
            "Business Networking",
            "Mentorship & Guidance",
            "Startup Tools Access",
            "Exclusive Community",
            "Growth Opportunities",
            "Investor Exposure",
          ].map((benefit, i) => (
            <Col md={4} key={i}>
              <motion.div
                className="benefit-box"
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                {benefit}
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* =========================
     4. Founder Quote Section
========================= */}
      <Container fluid className="quote-section py-5">
        <Container>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="quote-box text-center"
          >
            <h3>"Great companies are built with great people."</h3>
            <p>- Founder</p>
          </motion.div>
        </Container>
      </Container>

      {/* =========================
     5. FAQ Section
========================= */}
      <Container className="faq-section py-5">
        <h2 className="text-center mb-4">Frequently Asked Questions</h2>

        <div className="faq-box">
          <details>
            <summary>What is the founder membership fee?</summary>
            <p>The founder membership fee is ₹10,000.</p>
          </details>

          <details>
            <summary>What benefits will I receive?</summary>
            <p>
              You will get mentorship, networking, startup tools, and community
              access.
            </p>
          </details>

          <details>
            <summary>Is it a one-time fee?</summary>
            <p>Yes, it is a lifetime one-time fee.</p>
          </details>
        </div>
      </Container>

      {/* footer */}
      <Footer />
    </div>
  );
};

export default Founder;
